module.exports = __webpack_public_path__ + "static/media/additional-info.a4267bbb.png";